import script from "./CompleteProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteProfileModal.vue?vue&type=script&setup=true&lang=ts"

import "./CompleteProfileModal.vue?vue&type=style&index=0&id=acf2a306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acf2a306"]])

export default __exports__